import { IProductPricedPerCollectionLevel1 as productLevel1Type } from '@engyalo/storefront-types/lib/graphql/product'
import { IProductLevel2, IProductLevel3 } from '@engyalo/storefront-types/lib/plugins/model'

export const getTotalPrice = (product: productLevel1Type): number => {
    let totalPrice = 0

    if (product && product.price) {
        const { price, customizations } = product

        totalPrice += price

        if (customizations) {
            customizations.forEach((level2: IProductLevel2 | null) => {
                if (level2) {
                    const { customizations: level2Customizations } = level2

                    if (level2Customizations) {
                        level2Customizations.forEach((level3: IProductLevel3 | null) => {
                            if (level3) {
                                const { quantity, price } = level3

                                if (price && quantity) {
                                    const level3Price = price * quantity
                                    totalPrice += level3Price
                                }
                            }
                        })
                    }
                }
            })
        }
    }

    return totalPrice
}
